/**
 * @ngdoc directive
 * @name cbl.finanza.mf.directive:finanzaOperazioni
 * @restrict E
 * @scope
 * @description Menu a tendina per scegliere l'operazione da effettuare sui dossier
 * @param {String} sceltaDossierStato - Nome dello stato in cui è contenuta la lista dei dossier
 * @param {Object} ndg - Ndg dell'intestatario
 */
(function() {
	"use strict";
	var OperazioniCtrl = function($http, $state, $scope, messaggiFctr,
			labelSrvc, CONSTANTS, $stateParams) {
		this.$http = $http;
		this.$state = $state;
		this.messaggiFctr = messaggiFctr;
		$scope.msg = labelSrvc.getLabel;
		this.$stateParams = $stateParams;
		this.abilitato = false;
		this.vociMenu = [];

		var self = this;

		this.$http({
			method : 'GET',
			url : CONSTANTS.MOCK_ROOT + CONSTANTS.MOCK_REST.MENU
		}).then(function(response) {
			if (self.messaggiFctr.processaResponse(response)) {
				self.vociMenu = [];
				self.abilitato = false;
				return;
			}
			self.vociMenu = response.data.result;
			self.abilitato = true;
		}, function(reason) {
			self.messaggiFctr.processaResponse(reason);
			self.vociMenu = [];
			self.abilitato = false;
		});

		/**
		 * @ngdoc method
		 * @name apriPagina
		 * @methodOf cbl.finanza.mf.directive:finanzaOperazioni
		 * @description Apre la pagina interessata
		 * @param {Object}
		 *            voce - L'oggetto voce contenente l'identificativo della
		 *            sezione in cui si vuole andare
		 */
		this.apriPagina = function(voce) {
			if (voce.abilitato) {
				self.$stateParams.ndg = self.ndg;
				self.$stateParams.finServizio = voce.cod;
				self.$state.go(self.sceltaDossierStato ? self.sceltaDossierStato : "sceltadossier", self.$stateParams);
			} else {
				self.messaggiFctr.addMessage({
					type : 'W',
					message : voce.motivo
				});
			}
		};
	};

	OperazioniCtrl.$inject = [ '$http', '$state', '$scope', 'FinMessaggiFctr', 'FinLabelSrvc', 'FIN_CONSTANTS', '$stateParams' ];

	var TemplateUrl = function(CONSTANTS) {
		return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + "operazioni/operazioni.html";
	};
	TemplateUrl.$inject = [ 'FIN_CONSTANTS' ];

	var OperazioniComponent = {
		bindings : {
			sceltaDossierStato : '@',
			ndg : '<'
		},
		controller : OperazioniCtrl,
		controllerAs : "operazioniCtrl",
		templateUrl : TemplateUrl
	};

	angular.module("cbl.finanza.mf").component("finanzaOperazioni",
			OperazioniComponent);
}());


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/operazioni/operazioni.cmpt.js
 ** module id = 13
 ** module chunks = 0 1 2
 **/